export enum SelectSubtypes {
  SINGLE_CHECKBOX = 'Single Checkbox',
  MULTI_CHECKBOXES = 'Multi-Select Checkboxes',
  RADIO_BUTTONS = 'Radio Buttons',
  SINGLE_DROPDOWN = 'Single Select Dropdown',
  MULTI_DROPDOWN = 'Multi-Select Dropdown'
}

export interface SelectOption {
  value: string;
  id: string;
  status: string;
  utilize: string;
}

export interface Disposition {
  dispositionCode: string;
  description: string;
}
